export function isSearchBot(userAgent: string | null): boolean {
  if (!userAgent) return false;

  const botPatterns = [
    /Googlebot/i,
    /Bingbot/i,
    /YandexBot/i,
    /AhrefsBot/i,
    /DuckDuckBot/i,
    /Baiduspider/i,
    /Sogou/i,
    /Exabot/i,
    /facebot/i,
    /ia_archiver/i,
    /Twitterbot/i,
    /LinkedInBot/i,
    /Pinterest/i,
    /Slurp/i,
    /SemrushBot/i,
    /MJ12bot/i,
    /DotBot/i,
    /SeznamBot/i,
    /PetalBot/i,
    /MegaIndex/i,
    /UptimeRobot/i,
    /SiteAuditBot/i,
    /AdsBot-Google/i,
    /Google-Structured-Data-Testing-Tool/i,
    /Google-Site-Verification/i,
    /Google-InspectionTool/i,
  ];

  return botPatterns.some(pattern => pattern.test(userAgent));
}
